import React from 'react'
import { useAuth } from '../../hooks/context/UserAuthContext'

const ListItemAvatar = React.lazy(() => import('@mui/material/ListItemAvatar'))
const ListItemText = React.lazy(() => import('@mui/material/ListItemText'))
const MenuItem = React.lazy(() => import('@mui/material/MenuItem'))

const UserAvatar = React.lazy(() => import('./UserAvatar'))

const ProfileMenuItem = (props, ref) => {
  const auth = useAuth()

  return (
    <React.Suspense fallback={<div />}>
      <MenuItem ref={ref} {...props}>
        <ListItemAvatar>
          <UserAvatar user={auth.user} />
        </ListItemAvatar>
        <ListItemText primary={auth.user?.name} secondary={auth.user && `${auth.user?.email}`} />
      </MenuItem>
    </React.Suspense>
  )
}

export default React.forwardRef(ProfileMenuItem)
